export const features = [
  {
    icon: 'BookOpen',
    title: 'Curated Feed',
    description: 'No doomscrolling, no trolls, no bots. Your feed is curated directly from content you care about.'
  },
  {
    icon: 'Sparkles',   
    title: 'AI Digest',
    description: 'Automatically transform podcasts, articles, and videos into bite-sized highlights you can scroll through in minutes.'
  },
  {
    icon: 'ClipboardList',
    title: 'Clipboard',
    description: 'Add articles, topics, media, and more to your clipboard. Escarole\'s AI turns your clipboard contents into a personalized feed.'
  },
  {
    icon: 'Send',
    title: 'Convenience',
    description: 'Send texts, forward emails, and more to your clipboard and escarole will conveniently add content to your feed.'
  },
  {
    icon: 'Layers',
    title: 'Abstractions & Drill-Downs',
    description: 'Go up or down the rabbit hole with ease. Escarole\'s AI helps you understand complex topics and find related content.'
  },
  {
    icon: 'MessagesSquare',
    title: 'Social Context',
    description: 'See discussions and related content from across the web.'
  }
];

